import { FC } from "react";
import styles from './Download.module.less';
import banner from '../assets/banner3.png';
import { Breadcrumb } from 'antd';
import { useNavigate } from "react-router";
import DownloadList from "../components/DownloadList";


const Index: FC = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.body}>
            <div style={{height: '280px'}}>
                <img src={banner} alt="" />
            </div>
            <div className={styles.fix}>
            <div style={{width: '1200px', position: 'relative'}}>
                <div className={styles.banner}>
                    <div className={styles.title}>
                        文件下载
                    </div>
                </div>
                <div className={styles.breadcrumb}>
                    <Breadcrumb>
                        <Breadcrumb.Item className={styles.bread} onClick={() => navigate('/')}>首页</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.bread}>文件下载</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
            </div>
            <div className={styles.list}>
                <DownloadList width='960px' data={[{},{},{}]}></DownloadList>
            </div>
        </div>
    );
}

export default Index;